<span class="tt-ai-chat-thinking" aria-hidden="true">
    <span class="fa-stack tt-ai-chat-thinking__symbol">
        <i class="fal fa-flower fa-stack-1x"></i>
        <i class="fal fa-flower fa-stack-1x tt-ai-chat-thinking__flower--rotated"></i>
    </span>
</span>
